import { render, staticRenderFns } from "./study-details-pdf.vue?vue&type=template&id=5c058e3a&scoped=true&"
import script from "./study-details-pdf.vue?vue&type=script&lang=js&"
export * from "./study-details-pdf.vue?vue&type=script&lang=js&"
import style0 from "./study-details-pdf.vue?vue&type=style&index=0&id=5c058e3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c058e3a",
  null
  
)

component.options.__file = "study-details-pdf.vue"
export default component.exports